import * as React from "react"
import {useEffect} from "react"
import {number, object} from "yup";
import {AutocompleteAsyncDebounced} from "@components";
import {useValidatorSeeker} from "@ui-seeker/app";

import {BACKEND_APIS} from "@constants";
import {useMatchersSkusForm} from "../../@hooks";
import {matcherSKUDrawerError} from "../../@signals";


export default function MatchersSKUsDrawerBrand() {
	const { localValue, handleChange } = useMatchersSkusForm('brandID')
	const { errors } = useValidatorSeeker({
		brandID: localValue
	}, object({
		brandID: number().required('Brand is mandatory')
	}))

	useEffect(() => {
		matcherSKUDrawerError.value = {
			...matcherSKUDrawerError.value,
			brandID: errors?.brandID
		}
	}, [errors?.brandID]);

    return <AutocompleteAsyncDebounced
        urlAjax={`${BACKEND_APIS.BRANDS}/crud/brand/find-options`}
        label="Brand"
        placeholder="Please select a brand"
		value={localValue || ''}
		onChange={newValue => handleChange(newValue.target.value)}
		error={errors?.brandID}
	/>
}
